import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import { EventNames } from './event-names';

@Directive({
  selector: '[appPreventEvent]',
})
export class PreventEventDirective implements OnInit, OnDestroy {
  @Input('appPreventEvent') event: EventNames;
  @Input() stopPropagationOnly: boolean;
  listener: () => void;

  constructor(private renderer: Renderer2, private host: ElementRef) {}

  ngOnInit(): void {
    this.listener = this.renderer.listen(this.host.nativeElement, this?.event, (e: MouseEvent) => {
      if (this.stopPropagationOnly) {
        this.eventStopPropagation(e);
      } else {
        this.eventGeneralBlock(e);
      }
    });
  }

  private eventGeneralBlock(e: MouseEvent): void {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();
  }

  private eventStopPropagation(e: MouseEvent): void {
    e.stopPropagation();
    e.stopImmediatePropagation();
  }

  ngOnDestroy(): void {
    if (this.listener) {
      this.listener();
    }
  }
}
